import InvoicesContainer from './InvoicesContainer';

export {
    InvoicesContainer
};

export default InvoicesContainer;
